import React from 'react'
import { useAuth } from '../../hooks/useAuth'

export default function Notik() {

    const { user } = useAuth();
  return (
    <iframe src={`https://notik.me/coins?api_key=vmEwcuFBXZ1fT6MPgN9bwuhjQVhz21tA&pub_id=edFpis&app_id=6oaZQkqAT9&user_id=${user.id}`} width="100%" frameBorder="0" height="1000px"></iframe>
  )
}